var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"badge-block"},[_c('small',{staticStyle:{"position":"relative","text-align":"center"}},[_vm._v(_vm._s(_vm.dataConsulta))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticClass:"my-badge",class:_vm.getBadgeClass(_vm.ultimoResultado, _vm.label)},[_vm._v(_vm._s(_vm.label))])])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0fd1775e","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/common/BadgeConsulta.vue
// module id = Bxep
// module chunks = 1